(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('FtDiscountPopup');
    if (!popup) return;

    var storageKeys = {
      subscribed: 'ft_discount_popup_subscribed',
      hiddenUntil: 'ft_discount_popup_hidden_until'
    };

    var delay = parseInt(popup.getAttribute('data-ft-delay') || '15000', 10);
    var dismissDays = parseInt(popup.getAttribute('data-ft-dismiss-days') || '7', 10);
    var discountCode = popup.getAttribute('data-ft-code') || 'FIETS10';
    var mailchimpUrl = popup.getAttribute('data-ft-mailchimp-url') || '';

    var form = popup.querySelector('[data-ft-discount-form]');
    var formScreen = popup.querySelector('[data-ft-popup-form-screen]');
    var successScreen = popup.querySelector('[data-ft-popup-success-screen]');
    var closeButtons = popup.querySelectorAll('[data-ft-popup-close]');
    var copyButton = popup.querySelector('[data-ft-copy-code]');
    var copiedMessage = popup.querySelector('[data-ft-copied]');
    var errorMessage = popup.querySelector('[data-ft-popup-error]');
    var submitButton = popup.querySelector('[data-ft-submit-button]');
    var submitText = popup.querySelector('[data-ft-submit-text]');
    var submitLoading = popup.querySelector('[data-ft-submit-loading]');

    function now() {
      return new Date().getTime();
    }

    function isSubscribed() {
      return localStorage.getItem(storageKeys.subscribed) === 'true';
    }

    function isTemporarilyHidden() {
      var hiddenUntil = parseInt(localStorage.getItem(storageKeys.hiddenUntil) || '0', 10);
      return hiddenUntil && now() < hiddenUntil;
    }

    function setTemporaryHide() {
      var until = now() + dismissDays * 24 * 60 * 60 * 1000;
      localStorage.setItem(storageKeys.hiddenUntil, String(until));
    }

    function setSubscribed() {
      localStorage.setItem(storageKeys.subscribed, 'true');
      localStorage.removeItem(storageKeys.hiddenUntil);
    }

    function openPopup() {
      if (isSubscribed() || isTemporarilyHidden()) return;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ft-popup-lock');
    }

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ft-popup-lock');

      if (!isSubscribed()) {
        setTemporaryHide();
      }
    }

    function showSuccess() {
      setSubscribed();

      if (formScreen) formScreen.hidden = true;
      if (successScreen) successScreen.hidden = false;
      if (errorMessage) errorMessage.hidden = true;
    }

    function setLoading(isLoading) {
      if (!submitButton) return;
      submitButton.disabled = isLoading;
      if (submitText) submitText.hidden = isLoading;
      if (submitLoading) submitLoading.hidden = !isLoading;
    }

    function showError(message) {
      if (!errorMessage) return;
      errorMessage.textContent = message || 'Er ging iets mis. Probeer het opnieuw.';
      errorMessage.hidden = false;
    }

    function normalizeMailchimpMessage(message) {
      var div = document.createElement('div');
      div.innerHTML = message || '';
      return (div.textContent || div.innerText || '').trim();
    }

    function submitToMailchimp(email, botValue) {
      return new Promise(function (resolve, reject) {
        if (!mailchimpUrl) {
          reject(new Error('Mailchimp is nog niet gekoppeld.'));
          return;
        }

        var callbackName = 'ftMailchimpCallback_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
        var script = document.createElement('script');
        var url = mailchimpUrl;
        var separator = url.indexOf('?') === -1 ? '?' : '&';

        window[callbackName] = function (response) {
          cleanup();
          resolve(response || {});
        };

        function cleanup() {
          if (script.parentNode) script.parentNode.removeChild(script);
          try {
            delete window[callbackName];
          } catch (error) {
            window[callbackName] = undefined;
          }
        }

        script.onerror = function () {
          cleanup();
          reject(new Error('Mailchimp kon niet worden bereikt.'));
        };

        script.src = url + separator + 'EMAIL=' + encodeURIComponent(email) +
          '&b_0311047431e7034d7aba54378_f70fb718b4=' + encodeURIComponent(botValue || '') +
          '&c=' + callbackName;

        document.body.appendChild(script);
      });
    }

    if (!isSubscribed() && !isTemporarilyHidden()) {
      window.setTimeout(openPopup, delay);
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closePopup();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup();
      }
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var emailInput = form.querySelector('input[type="email"]');
        var botInput = form.querySelector('input[name="b_0311047431e7034d7aba54378_f70fb718b4"]');
        var email = emailInput ? emailInput.value.trim() : '';
        var botValue = botInput ? botInput.value : '';

        if (!emailInput || !emailInput.checkValidity()) {
          if (emailInput) emailInput.reportValidity();
          return;
        }

        setLoading(true);
        if (errorMessage) errorMessage.hidden = true;

        submitToMailchimp(email, botValue)
          .then(function (response) {
            var result = response.result || '';
            var message = normalizeMailchimpMessage(response.msg || '');
            var alreadySubscribed = /already subscribed|is already subscribed|reeds ingeschreven|al ingeschreven/i.test(message);

            if (result === 'success' || alreadySubscribed) {
              showSuccess();
              return;
            }

            showError(message || 'Controleer je e-mailadres en probeer het opnieuw.');
          })
          .catch(function () {
            showError('Er ging iets mis met inschrijven. Probeer het straks opnieuw.');
          })
          .finally(function () {
            setLoading(false);
          });
      });
    }

    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var done = function () {
          if (copiedMessage) copiedMessage.hidden = false;
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(discountCode).then(done).catch(done);
        } else {
          done();
        }
      });
    }
  });
})();
